import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { Observable } from 'rxjs';
import { CleanupService } from '../../shared/utils/cleanup.service';

// TODO Kann umgebaut/entfernt werden. Mit NOWSUCHE-1847 wurde aufgrund eines BF Findings das Collapse in 2024 entfernt.
//  Seitdem hat sich nichts getan. Teile wurden bereits entfernt. Den Code kann man via Versionshistorie zur Not wiederherstellen
@Component({
  selector: 'now-wbsuche-lib-responsive-collapse',
  templateUrl: './responsive-collapse.component.html',
  styleUrls: ['./responsive-collapse.component.scss'],
  providers: [CleanupService],
  imports: [CommonModule]
})
export class ResponsiveCollapseComponent implements OnChanges {
  private readonly element = inject(ElementRef);

  @Input()
  maxHeight = 200;

  @Input()
  collapseButtonText = '';

  @Input()
  // Updates the collapse state (recalculates the height etc)
  // True => sets the collapsed property to true
  // False => keeps the current collapsed value
  updateCollapse?: Observable<boolean>;

  @Output()
  collapsedChange = new EventEmitter<boolean>();

  public showCollapseButton = false;
  public collapsed = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.maxHeight?.currentValue !== changes.maxHeight?.previousValue) {
      this.element.nativeElement.style.setProperty(
        '--content-wrapper-max-height',
        `${this.maxHeight}px`
      );
    }
  }

  public toggleCollapse(event: Event): void {
    event.preventDefault();
    this.setCollapsed(!this.collapsed);
  }

  private setCollapsed(collapsed: boolean): void {
    this.collapsed = collapsed;
    this.collapsedChange.emit(this.collapsed);
  }
}
